export function getItemClass(active: boolean, idx: number, optionsLength: number) {
  return {
    active,
    start: idx === 0,
    center: idx > 0 && idx < optionsLength,
    end: idx === optionsLength - 1,
  };
}
